export default __webpack_public_path__ + "static/media/Logout.2b63e0aa.svg";